import React from "react";
import { ButtonV2 } from "../../../ButtonV2/ButtonV2";
export const TTAccBannerButtonAndLink = ({ buttonLink, buttonText, openInNewTab, linkButtonLabel, linkButtonUrl }) => {
    const hasTextLink = linkButtonLabel && linkButtonUrl;
    return React.createElement("div", { className: "thinktrader-account-banner__button-wrapper" },
        buttonLink && React.createElement(ButtonV2, { design: "tmx25-round-green-lightgreen", href: buttonLink, openInNewTab: openInNewTab, showArrowRight: true }, buttonText),
        hasTextLink && React.createElement("a", { className: "link-button", rel: "noreferrer", target: "_blank", href: linkButtonUrl }, linkButtonLabel));
};
